import { redirect } from 'react-router-dom';

import { setCurrentModal } from 'src/app/reducers/modal-states.reducer';
import { store } from 'src/app/store';
import { ModalType } from 'src/common/enums';
import type { CampaignName } from 'src/common/enums/campaigns';
import { storeActiveCampaignSession } from 'src/features/campaigns/helpers';
import { IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY } from 'src/features/dashboard/dashboard.constants';

import type {
  INFLUENCER_ADDITIONAL_CONFIGS,
  INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS,
  InfluencerCampaigns,
  InfluencerSubscriptionCampaigns,
} from '../influencers.config';

export type InfluencerConfig = (typeof INFLUENCER_ADDITIONAL_CONFIGS)[InfluencerCampaigns];
export type InfluencerSubscriptionConfig =
  (typeof INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS)[InfluencerSubscriptionCampaigns];

export const influencerRouteLoader = async (campaignName: CampaignName, config: InfluencerConfig) => {
  const { dispatch } = store;
  const { detailsRedirect, landingRedirect } = config;
  dispatch(setCurrentModal(ModalType.INFLUENCER_CAMPAIGN));
  await storeActiveCampaignSession(campaignName);
  const loggedIn = document.cookie.includes('logged-in-hint');
  const redirectUrl = loggedIn ? detailsRedirect : landingRedirect;
  localStorage.removeItem(IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY);

  return redirect(redirectUrl);
};

export const influencerSubscriptionRouteLoader = async (
  campaignName: CampaignName,
  config: InfluencerSubscriptionConfig,
) => {
  const { dispatch } = store;
  const { page } = config;
  dispatch(setCurrentModal(ModalType.INFLUENCER_CAMPAIGN));
  await storeActiveCampaignSession(campaignName);
  localStorage.removeItem(IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY);

  return redirect(page);
};
